import React, { useState, useEffect } from "react";
import "./favo.css";
import { ImgCabecera } from "../../componentes/imgCabecera/imgCabe";
import { NavBar } from "../../componentes/navbar/index";
import { Card } from "../../componentes/cards/card";
import iconoEliminar from "../../img/iconoEliminar.png";
import apiClient from '../../acciones/apiClient';
import { useParams } from "react-router-dom"; 
import { jwtDecode } from 'jwt-decode';


export const Favoritos = () => {
    const { id } = useParams(); 
    const [favoritos, setFavoritos] = useState([]); // Lista de proyectos favoritos
    const [showModal, setShowModal] = useState(false);
    const [favoritoAEliminar, setFavoritoAEliminar] = useState(null); // Proyecto seleccionado para eliminar

    // Abrir el modal para confirmar eliminación
    const handleDelete = (proyecto_id) => {
        setFavoritoAEliminar(proyecto_id);
        setShowModal(true);
    };

    // Cerrar el modal
    const closeModal = () => {
        setShowModal(false);
        setFavoritoAEliminar(null);
    };

    // Confirmar eliminación
    const confirmDelete = async () => {
        try {
            const token = localStorage.getItem('token');
            if (!token) throw new Error('Token no encontrado');
    
            const userId = jwtDecode(token).id; // Extraer el ID del token
    
            console.log('Eliminando favorito:', { user_id: userId, proyecto_id: favoritoAEliminar });
    
            await apiClient.delete(`/usuarios/favoritos`, {
                data: { user_id: userId, proyecto_id: favoritoAEliminar },
            });
    
            // Actualizar la lista local de favoritos
            setFavoritos(favoritos.filter((fav) => fav.id !== favoritoAEliminar));
            closeModal();
        } catch (error) {
            console.error('Error al eliminar favorito:', error);
        }
    };
    


    // Fetch para obtener favoritos al cargar el componente
    useEffect(() => {
        const fetchFavoritos = async () => {
            try {
                const response = await apiClient.get(`/usuarios/favoritos/${id}`);
                setFavoritos(response.data);
            } catch (error) {
                console.error("Error al obtener favoritos:", error);
            }
        };        
        
        fetchFavoritos();
    }, [id]);




    return (
        <div>
            <ImgCabecera />
            <NavBar />

            <br />

            <div className="todoFavoritos">
                <h1>Favoritos</h1>
                <br />
                <br />
                <div className="favoritos-grid">
                    {favoritos.length > 0 ? (
                        favoritos.map((favorito) => (
                            <div key={favorito.id} className="favorito-card">
                                <Card
                                    id={favorito.id}
                                    cover={favorito.cover}
                                    title={favorito.title}
                                    author={favorito.author}
                                />
                                <img
                                    src={iconoEliminar}
                                    alt="Eliminar"
                                    className="icono-eliminarFavoritos"
                                    onClick={() => handleDelete(favorito.id)}
                                />
                            </div>
                        ))
                    ) : (
                        <p>No tienes proyectos favoritos aún.</p>
                    )}
                </div>

            </div>

            {showModal && (
                <div className="modalFavoritos">
                    <div className="modal-contentFavoritos">
                        <h2>¿Está seguro de eliminarlo de favoritos?</h2>
                        <button onClick={confirmDelete}>Sí</button>
                        <button onClick={closeModal}>No</button>
                    </div>
                </div>
            )}
        </div>
    );
}
